import React, {useContext, useEffect, useState} from "react";
import Chart from 'chart.js/auto';
import "../../../../css/page/content/analyze/Stat.css";
import BackofficeContext from "../../../../context/BackofficeContext";

const MiniChart = props => {
    const { classname, idChart, datas } = props;
    const { setBubbleText } = useContext(BackofficeContext);
    const [ chart, setChart ] = useState(null);
    const [ buildDatas, setBuildDatas ] = useState(null);
    const LOG = false;
    const borderColor = "#FFFFFF80";
    const lineTension = 0.15;

    const extractDatas = () => {
        if (LOG) console.log(idChart + " DATAS", datas);
        if (datas === undefined || datas === null) return

        let buildDatasTmp = [];

        try {
            if (datas.date === undefined || datas.date === null) throw new Error();
            if (datas.date.subperiods === undefined || datas.date.subperiods === null) throw new Error();

            for (let i in datas.date.subperiods) {
                let data = datas.date.subperiods[i];
                if (data.datas === undefined || data.datas === null) throw new Error();

                switch (idChart) {
                    case "chartCA":
                        buildDatasTmp.push(data.datas.inclTax);
                        break;
                    case "chartNbSales":
                        buildDatasTmp.push(data.datas.nb);
                        break;
                    case "chartAverage":
                        buildDatasTmp.push(data.datas.averagePrice);
                        break;
                    default: break;
                }
            }
        }
        catch (e) {
            console.error("MiniChart.extractDatas", e);
        }

        setBuildDatas(buildDatasTmp);
    }
    const initChart = () => {
        if (buildDatas === null) return;
        if (chart !== null) {
            updateChart();
            return;
        }

        const ctx = document.getElementById(idChart);
        if (ctx === null) return;

        const options = {
            responsive: false,
            maintainAspectRatio: false,
            aspectRatio: 2.31,
            animation: {
                duration: 0
            },
            scales: {
                x: {
                    display: false,
                    border: {
                        display: false
                    },
                    grid: {
                        display: false,
                        drawOnChartArea: false,
                        drawTicks: false
                    }
                },
                y: {
                    display: false,
                    grid: {
                        display: false,
                        drawOnChartArea: false,
                        drawTicks: false
                    }
                }
            },
            plugins: {
                legend: {
                    display: false
                }
            },
            events: []
        };
        const data = {
            labels: ['1','2','3','4','5','6'],
            datasets: [{
                data: buildDatas,
                borderColor: borderColor,
                pointStyle: false,
                lineTension: lineTension
            }]
        };

        try {
            const chartObj = new Chart(ctx, {
                type: 'line',
                data: data,
                options: options
            });

            setChart(chartObj);
        }
        catch (error) {
            console.error("CHART ERROR", error);
        }
    }
    const updateChart = () => {
        if(chart === null) return;

        const datasets = [{
            data: buildDatas,
            borderColor: borderColor,
            pointStyle: false,
            lineTension: lineTension
        }];

        chart.data.datasets = datasets;
        chart.update();

        animChart(false);
    }
    const animChart = anim => {
        if (chart === null) return;

        if (anim) {
            chart.options.animation = {
                duration: 500
            }
        }
        else {
            chart.options.animation = {
                duration: 0
            }
        }
    }
    const init = () => {
        initChart();
    }

    useEffect(() => {
        init();
    }, []);
    useEffect(() => {
        extractDatas();
    }, [datas]);
    useEffect(() => {
        initChart();
    }, [buildDatas]);

    return (
        <div className={ "miniChart" + (classname !== undefined ? " " + classname : "") } onMouseOver={() => { setBubbleText("Tendance des 6 derniers jours") }} onMouseOut={() => { setBubbleText(null) }}>
            <canvas id={idChart} className={"chart"} />
        </div>
    )
}

export default MiniChart;
